import styled from 'styled-components'

export const Section = styled.div`
  margin-bottom: 35px;
  text-align: center;
`

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
